import * as ajax from '@/shared/API/Root/ajax';
import * as rest from '@/shared/API/Root/rest';
import type { GetTokenPayload } from '@/shared/API/Root/payloads';
import getFactory from '@/shared/utils/factory';

const factory = getFactory<typeof ajax>(ajax);

export function useAuthApi() {
    return {
        checkCookie: () => factory.checkCookie(),
        getToken: (payload: GetTokenPayload) => rest.getToken(payload),
        createSession: (accessToken: string) => rest.createSession({
            accessToken
        }),
    };
}
